import React from "react";

function AadilRehmanCode() {
  return (
    <>
      <div className="code_container">
        <div className="html_code code">
          <h1>HMTL</h1>
          <pre class="mycode">
            {`

  <!DOCTYPE html>
  <html>
  
  <head>
      <title>
          Aadil rehman
      </title>
      <link rel="stylesheet" href="index2.css">
  </head>
  
  <body>
  
      <div class="top" id="top">
          <div class="menu">
              <div class="logo">
                  <img src="logo4.png" alt="">
              </div>
              <div class="header-link">
                  <a href="#">Home</a>
                  <a href="#middle">About</a>
                  <a href="#my">Services</a>
                  <a href="#skill">Skills</a>
                  <a href="#team">Teams</a>
                  <a href="#contact">Contact</a>
              </div>
  
          </div>
  
          <div class="about">
              <div class="hello">Hello, my name is</div>
              <div class="aadil"><span>A</span>adil rehman</div>
              <div class="and">And I'am a<span class="youtuber">
                      YouTuber</span></p>
              </div>
              <div class="hire">
                  <p>Hire me
              </div>
              <div class="icon1"><a href="#top"><img src="icon1.png" alt="icin1"></a></div>
          </div>
  
      </div>
      <div class="middle" id="middle">
          <div class="aboutme">
              <h1>About me</h1>
          </div>
          <div class="who">who i am
  
          </div>
  
          <div class="aadilphoto">
              <img src="aadil3.jpg" alt="aadil photo">
          </div>
          <div class="Im">
              <div class="im">
                  <h1>I'm Aadil and I'm a <span class="youtuber2">YouTuber</span></h1>
              </div>
              <div class="lorem">
                  <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit.
                      Dolores, nulla alias officiis fuga voluptatem provident
                      asperiores similique praesentium voluptates veritatis,
                      neque ut fugit quod suscipita sapiente itaquee ipsam cupiditate qui.
                      Lorem, ipsum dolor is sit amet the consectetur adipisicing elit.
                      Dolores nulla alias officiis fuga they are voluptatem provident
                      asperiores similique praesentium ut voluptates consectetur veritatis,
                      neque is fugit quodr suscipit sapiente itaque ipsam cupiditate qui
                  </p>
                  <div class="download">
                      <p>Download CV</p>
                  </div>
              </div>
          </div>
          <div class="my" id="my">
              <h1 class="serviecs">My Services</h1>
              <p class="what">what i provied</p>
  
              <div class="box">
                  <h1>Web Design</h1>
                  <p>Lorem ipsum dolor sit amet consectetur
                      adipisicing elit. Quasi fugit voluptatem
                      earum nesciunt, quam eveniet omni
                      Lorem ipsum dolor consectetur
                      adipisicing elit. Quasi fugit voluptatem
                      earum nesciunt. </p>
              </div>
              <div class="box">
  
                  <h1>Advertising</h1>
                  <p>Lorem ipsum dolor sit amet consectetur
                      adipisicing elit. Quasi fugit voluptatem
                      earum nesciunt, quam eveniet omni
                      Lorem ipsum dolor consectetur
                      adipisicing elit. Quasi fugit voluptatem
                      earum nesciunt. </p>
  
              </div>
              <div class="box">
                  <h1>Apps Design</h1>
                  <p>Lorem ipsum dolor sit amet consectetur
                      adipisicing elit. Quasi fugit voluptatem
                      earum nesciunt, quam eveniet omni
                      Lorem ipsum dolor consectetur
                      adipisicing elit. Quasi fugit voluptatem
                      earum nesciunt. </p>
              </div>
          </div>
          <div class="skill" id="skill">
              <h1 class="myskills">My skills</h1>
              <p class="what2">what i know</p>
              <div class="para">
                  <h1 class="mycreative">My creative skills & experiences.</h1>
                  <p class="lorem2">Lorem ipsum dolor sit amet consectetur adipisicing elit.
                      Non consequuntur alias voluptates esse veniam doloremque
                      pariatur hic quidem distinctio fuga soluta ea ut consequatur
                      nobis vero provident, est ipsa ad.Lorem ipsum dolor sit amet
                      consectetur adipisicing elit. Non consequuntur alias voluptates
                      esse veniam dolor pariatur hic quidem distinctio fuga soluta
                      ea ut consequ nobis vero provident, est ipsa adLorem ipsum dolor sit amet consectetur adipisicing
                      elit.
                      Non consequuntur alias voluptates esse veniam doloremque.
                  </p>
              </div>
              <div class="read">
                  <p>Read more</p>
              </div>
              <div class="skills2">
                  <li>
                      <h3>HTML <span class="h90">90%</span></h3><span class="bar"><span class="html"></span></span>
                  </li>
                  <li>
                      <h3>CSS <span class="h60">60%</span></h3><span class="bar"><span class="css"></span></span>
                  </li>
                  <li>
                      <h3>Javascript <span class="h80">80%</span></h3><span class="bar"><span
                              class="Javascript"></span></span>
                  </li>
                  <li>
                      <h3>PHP <span class="h50">50%</span></h3><span class="bar"><span class="php"></span></span>
                  </li>
                  <li>
                      <h3>MYSQL <span class="h70">70%</span></h3><span class="bar"><span class="mysql"></span></span>
                  </li>
              </div>
          </div>
          <div class="team" id="team">
              <h1>My team</h1>
              <p> who with me</p>
              <div class="box2">
                  <img src="aadil.jpg" class="aadilphoto2" alt="aadil">
                  <h1> Aadil Rehman</h1>
                  <h4>Hey I am Aadil Rehman an English Trainer & Motivational speaker.</h4>
              </div>
              <div class="box2">
                  <img src="aakil.jpg" class="aadilphoto2" alt="aadil">
                  <h1>Aakil Tayyab</h1>
                  <h4>Hey I am Aakil tayyab and I am Full-stack web developer.</h4>
              </div>
              <div class="box2">
                  <img src="abbuji.jpg" class="aadilphoto2" alt="aadil">
                  <h1>Tayyab Ameen</h1>
                  <h4>Hey I am Tayyab Ameen and I am a Full-stack Quran knowledge.</h4>
              </div>
          </div>
          <div class="contact" id="contact">
              <div class="contact2">
                  <h1>Contact me</h1>
                  <p>get in touch</p>
              </div>
              <div class="get">
                  <h1>Get in Touch</h1>
                  <p>Lorem ipsum dolor sit amet consectetur adipisicing ipsam
                      tenetur architecto veniam nobis, cupiditate laborum ipsam
                      tenetur architecto.</p>
              </div>
              <div class="contact-detels">
                  <h1><img src="name.png" alt=""><span>Name:</span></h1>
                  <h5>Aadil Rehman</h5>
                  <h1 class="contact3"><img src="contact-number.png" alt=""><span>Contact:</span></h1>
                  <h5>7065830366, 7011846946</h5>
  
                  <h1 class="email"><img src="email.png" alt=""><span>Email:</span></h1>
                  <h5>aadilrehman599@gmail.com</h5>
              </div>
              <div class="message">
                  <h1>Message me</h1>
                  <form action="#">
                      <input type="text" placeholder="Name.." required>
                      <input type="email" placeholder="Email.." required><br>
                      <input type="text" id="subject" placeholder="Subject.." required><br>
                      <div class="button"><input type="submit" value="Send message"></div>
                  </form>
  
              </div>
  
          </div>
          <div class="bottom"> Created By <span class="aakil-tayyab">Aakil Tayyab</span>|2020 ALL right reserved.</div>
      </div>
  
  </body>
  
  </html>
          `}
          </pre>
        </div>

        <div className="css_code code">
          <h1>CSS</h1>
          <pre class="mycode">
        {`
 * {
        margin: 0;
        padding: 0;
    }
    
    .icon1 img {
        width: 50px;
        position: fixed;
        margin-left: 1230px;
    margin-top: 100px;            }
    
    .icon1 img:hover {
        width: 52px;
                
    .icon1 img:active {
        width: 50Px;
    }
    
    .top {
        background-image: url("a1.jpg");
        height: 100vh;
        width: 100%;
        background-repeat: no-repeat;
        background-size: cover;
    
    }
    
    .menu {
        position: fixed;
        top: 0px;
        width: 100%;
        background-color: #0088A9;
    }
    
    
    .logo {
        display: inline;
    
    
    }
    
    .logo img {
        padding-top: 14px;
        padding-left: 38px;
        padding-bottom: 10px;
    
    }
    
    .header-link {
        display: inline;
        float: right;
        padding-top: 22px;
        margin-right: 40px;
        padding-right: 20px;
    
    
    }
    
    .header-link a {
        text-decoration: none;
        margin-left: 40px;
        color: white;
        font-size: 15px;
        font-family: sans-serif;
        transition: all 0.3s ease;
        transition-property: all;
        transition-duration: 0.3s;
        transition-timing-function: ease;
        transition-delay: 0s;
    
    
    }
    
    .header-link a:hover {
        color: crimson;
        font-size: 15.2px;
    }
    
    .header-link a:active {
        color: blueviolet;
    }
    
    .header-link a:focus {
        color: rgb(250, 140, 96);
    }
    
    .about {
    
        font-family: sans-serif;
        padding: 40px;
        padding-top: 210px;
        color: white;
    }
    
    .hello {
        font-size: 25px;
    
    }
    
    .aadil {
        font-size: 60px;
        margin-left: -3px;
        word-spacing: 6px;
        letter-spacing: 5px;
        color: white;
    
    }
    
    .and {
        font-size: 25px;
    
    }
    
    .youtuber {
        color: crimson;
        font-size: 35px;
    
    
    
    
    }
    
    .hire {
        border: 2px solid crimson;
        width: 100px;
        margin-top: 15px;
        background-color: crimson;
        color: white;
        border-radius: 10px;
        transition: all 0.3s ease;
        transition-property: all;
        transition-duration: 0.3s;
        transition-timing-function: ease;
        transition-delay: 0s;
    
    }
    
    .hire p {
        padding-left: 13px;
        margin: 10px;
        font-family: sans-serif;
    
    }
    
    .hire:hover {
        background-color: transparent;
        color: crimson;
        border-radius: 5px;
    
    }
    
    .middle {
        background-color: white;
        width: 100%;
        height: cover;
    }
    
    .aboutme {
        font-family: sans-serif;
        font-size: 20px;
        color: black;
        text-align: center;
        padding-top: 50px;
    }
    
    .who {
        display: flex;
        flex-direction: row;
        margin-left: 550px;
        margin-right: 550px;
        font-size: 20px;
        color: crimson;
        padding: 0 5px;
    
    
    }
    
    .who:before,
    .who:after {
        content: "";
        flex: 1 1;
        border-bottom: 2px solid black;
        margin: 8px;
    
    }
    
    .aadilphoto img {
        height: 390px;
        width: 320px;
        margin: 100px;
        border-radius: 5%;
        border: 0px solid crimson;
        display: inline;
        margin-top: 30px;
    }
    
    .Im {
        display: inline;
        float: right;
        width: 53%;
        margin-top: -420px;
        margin-right: 73px;
    
    }
    
    .im {
        font-size: 15px;
        font-family: sans-serif;
    
    }
    
    .lorem p {
        font-size: 17px;
        font-family: sans-serif;
        word-spacing: 4px;
        padding-top: 20px;
    
    
    }
    
    .youtuber2 {
        color: crimson;
        font-size: 40px;
    }
    
    .download {
        border: 2px solid crimson;
        width: 200px;
        margin-top: 20px;
        background-color: crimson;
        color: white;
        border-radius: 10px;
        transition: all 0.4s ease;
        transition-property: all;
        transition-duration: 0.4s;
        transition-timing-function: ease;
        transition-delay: 0s;
    }
    
    .download:hover {
        background-color: transparent;
        color: crimson;
        border: 2px solid crimson;
        border-radius: 5px;
        transition: all 0.3s ease;
        transition-property: all;
        transition-duration: 0.3s;
        transition-timing-function: ease;
        transition-delay: 0s;
    }
    
    .download p {
        font-family: sans-serif;
        font-size: 20px;
        text-align: center;
        padding-bottom: 10px;
        padding-top: 10px;
    
    }
    
    .my {
        background-color: black;
        width: 100%;
        height: 90vh;
    }
    
    .serviecs {
        color: white;
        text-align: center;
        font-size: 40px;
        font-family: sans-serif;
        padding-top: 80px;
    }
    
    .what {
        color: crimson;
        font-family: sans-serif;
        font-size: 18px;
        text-align: center;
        padding-top: 10px;
        display: flex;
        flex-direction: row;
        margin-left: 550px;
        margin-right: 550px;
    }
    
    .what:before,
    .what:after {
        content: "";
        flex: 1 1;
        border-bottom: 2px solid white;
        margin: 8px;
    }
    
    .box {
        border-radius: 15px;
        border: 1px solid crimson;
        width: 405px;
        height: 205px;
        float: left;
        margin: 16px;
        margin-top: 40px;
        margin-right: 26px;
        background-color: rgba(47, 45, 45, 0.5);
        transition: all 0.4s ease;
        transition-property: all;
        transition-duration: 0.4s;
        transition-timing-function: ease;
        transition-delay: 0s;
    }
    
    .box:hover {
        background-color: transparent;
        border: 1px solid crimson;
        border-radius: 5px;
    
    
    
    }
    
    .box h1 {
        color: crimson;
        text-align: center;
        padding-top: 30px;
        font-size: 25px;
        font-family: sans-serif;
    }
    
    .box p {
        text-align: center;
        font-family: sans-serif;
        padding-left: 30px;
        padding-top: 10px;
        color: white;
        width: 350px;
    }
    
    .skill {
        background-color: white;
        width: 100%;
        height: 90vh;
        display: block;
    }
    
    .myskills {
        color: black;
        text-align: center;
        font-size: 40px;
        font-family: sans-serif;
        padding-top: 60px;
    }
    
    .what2 {
        color: crimson;
        font-size: 20px;
        font-family: sans-serif;
        text-align: center;
        padding-top: 5px;
        display: flex;
        flex-direction: row;
        margin-left: 570px;
        margin-right: 570px;
    }
    
    .what2:before,
    .what2:after {
        content: "";
        flex: 1 1;
        border-bottom: 2px solid black;
        margin: 8px;
    }
    
    .para {
        padding-top: 60px;
        padding-left: 40px;
    }
    
    .mycreative {
        font-family: sans-serif;
        font-size: 25px;
        font-weight: 20%;
    
    }
    
    .lorem2 {
        font-family: sans-serif;
        font-size: 16px;
        width: 610px;
        padding-top: 10px;
        text-align: justify;
        word-spacing: 3px;
    
    }
    
    .read {
        width: 160px;
        margin-left: 40px;
        margin-top: 20px;
    }
    
    .read p:hover {
        background-color: transparent;
        color: crimson;
        border-radius: 5px;
        border: 2px solid crimson;
    }
    
    .read p {
        color: white;
        font-family: sans-serif;
        font-size: 20px;
        padding-top: 10px;
        padding-bottom: 10px;
        text-align: center;
        border-radius: 10px;
        background-color: crimson;
        transition: all 0.4s ease;
        transition-property: all;
        transition-duration: 0.4s;
        transition-timing-function: ease;
        transition-delay: 0s;
    
    }
    
    .skills2 {
        width: 590px;
        margin: 60px;
        margin-right: 40px;
        color: black;
        float: right;
        margin-top: -250px;
    
    }
    
    .skills2 li {
        margin: 20px 0;
        list-style: none;
        font-family: sans-serif;
    
    }
    
    .bar {
        background-color: lightgrey;
        border: 0px solid rgba(0, 0, 0, .3);
        border-radius: 3px;
        display: block;
        height: 5px;
        overflow: hidden;
        box-shadow: black;
    
    
    }
    
    .h90 {
        margin-left: 495px;
        font-family: sans-serif;
    }
    
    .h60 {
        margin-left: 508px;
    }
    
    .h80 {
        margin-left: 453px;
    }
    
    .h50 {
        margin-left: 507px;
    }
    
    .h70 {
        margin-left: 480px;
    }
    
    .bar span {
        height: 5px;
        float: left;
        background-color: crimson;
    
    }
    
    .html {
        width: 90%;
    }
    
    .css {
        width: 60%;
    }
    
    .Javascript {
        width: 80%;
    
    }
    
    .php {
        width: 50%;
    
    }
    
    .mysql {
        width: 70%;
    }
    
    .team {
        background-color: black;
        width: 100%;
        height: 95vh;
    
    }
    
    .team h1 {
        color: white;
        font-size: 40px;
        font-family: sans-serif;
        text-align: center;
        padding-top: 60px;
    }
    
    .team p {
        text-align: center;
        font-family: sans-serif;
        font-size: 20px;
        color: crimson;
        padding-top: 5px;
        display: flex;
        flex-direction: row;
        margin-left: 570px;
        margin-right: 570px;
    
    }
    
    .team p:before,
    .team p:after {
        content: "";
        flex: 1 1;
        border-bottom: 2px solid white;
        margin: 8px;
    }
    
    .box2 {
        border-radius: 15px;
        border: 1px solid crimson;
        width: 405px;
        height: 270px;
        float: left;
        margin: 16px;
        margin-top: 40px;
        margin-right: 26px;
        background-color: rgba(47, 45, 45, 0.5);
        transition: all 0.4s ease;
        transition-property: all;
        transition-duration: 0.4s;
        transition-timing-function: ease;
        transition-delay: 0s;
    }
    
    .box2:hover {
        background-color: transparent;
        border: 1px solid crimson;
        border-radius: 5px;
    }
    
    .box2 h1 {
        color: white;
        text-align: center;
        padding-top: 10px;
        font-size: 25px;
        font-family: sans-serif;
    }
    
    .aadilphoto2 {
        margin-left: 132px;
        margin-top: 20px;
        border-radius: 100%;
        border: 5px solid crimson;
    }
    
    .box2 h4 {
        font-family: sans-serif;
        color: white;
        text-align: center;
        padding: 10px;
    }
    
    .contact {
        background-color: white;
        width: 100%;
        height: 90vh;
    }
    
    .contact2 h1 {
        font-family: sans-serif;
        text-align: center;
        color: black;
        font-size: 40px;
        padding-top: 60px;
    }
    
    .contact p {
        color: crimson;
        font-size: 20px;
        padding-top: 5px;
        font-family: sans-serif;
        text-align: center;
        display: flex;
        flex-direction: row;
        margin-left: 550px;
        margin-right: 550px;
    }
    
    .contact p:before,
    .contact p:after {
        content: "";
        flex: 1 1;
        border-bottom: 2px solid black;
        margin: 8px;
    }
    
    .get h1 {
        font-family: sans-serif;
        font-size: 25px;
        color: black;
        margin-left: 35px;
        padding-top: 30px;
    }
    
    .get p {
        font-family: sans-serif;
        font-size: 18px;
        word-spacing: 1px;
        color: black;
        width: 680px;
        text-align: left;
        margin-left: 20px;
        padding-top: 10px;
        text-align: justify;
    }
    
    .contact-detels img {
        width: 40px;
        height: 40px;
        margin-left: 35px;
        padding-top: 30px;
    
    }
    
    .contact-detels span {
        font-family: sans-serif;
        font-size: 20px;
        padding-left: 15PX;
        color: darkslategrey;
    }
    
    .contact-detels h5 {
        font-size: 13px;
        color: lightslategrey;
        margin-left: 120px;
        font-family: sans-serif;
        padding-top: 5px;
    
    }
    
    .contact3 {
        margin-top: -35px;
    }
    
    .email {
        margin-top: -35px;
    }
    
    .email img {
        width: 36 !important;
        height: 36 !important;
    }
    
    .message {
        float: right;
        margin-top: -220px;
    }
    
    .message h1 {
        font-family: sans-serif;
        font-size: 20px;
        color: black;
        padding: 10px;
    }
    
    .message input {
        width: 280px;
        padding: 12px;
        margin: 5px;
        border: 1px solid lightslategrey;
        border-radius: 10px;
    }
    
    #subject {
        width: 600px;
    }
    
    .button input {
        border: 2px solid crimson;
        width: 170px;
        background-color: crimson;
        color: white;
        font-family: sans-serif;
        margin-left: 5px;
    
        font-size: 20px;
        padding: 7px;
        text-align: center;
        margin-top: 20px;
        border-radius: 7px;
    }
    
    .button input:hover {
        background-color: transparent;
        color: crimson;
        border-radius: 4px;
        transition: .4s;
        border: 2px solid crimson;
    }
    
    .button input:active {
        width: 170px;
        font-size: 19px;
        border: 2px solid crimson;
    }
    
    .bottom {
        background-color: rgb(41, 38, 38);
        width: 100%;
        height: 5vh;
        text-align: center;
        color: white;
        padding: 10px;
        font-size: 20px;
        font-family: sans-serif;
    }
    
    .aakil-tayyab {
        color: crimson;
    }
    
    `}
  </pre>
</div>
<div className="js_code code">
  <h1>JavaScript</h1>
  <pre class="mycode">
{`
    
      No JavaScript code  
      
    `}
  </pre>
</div>
      </div>
    </>
  );
}

export default AadilRehmanCode;
